import React, { useState } from "react"
import ReactModal from "react-modal"
import BotonIframeProyecto from "./BotonIframeProyecto"
import BotonGaleriaProyecto from "./BotonGaleriaProyecto"
import Button from "../atoms/Button/Button"
import ObtenerUri from "../../utils/ObtenerUri"
import "./BotonProyecto.scss"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "none",
    overflow: "initial",
    padding: 0,
  },
}

if (typeof window !== "undefined") {
  ReactModal.setAppElement("body")
}

const BotonProyecto = ({
  boton,
  brochure,
  settings,
  galeriaObra,
  linkPdf,
  parrafoAvance,
}) => {
  const { texto, idGa, ocultar, tipo } = boton
  const [modalOpen, setModalOpen] = useState(false)

  // Mismo contenido que abría antes en otra pestaña, ahora embebido:
  // - si hay linkPdf, la página del visor PDF de WordPress
  // - si no, el archivo del brochure directamente
  const domain = process.env.GATSBY_PAGINA_COMPILADOR
  const pdfSrc = boton?.linkPdf?.uri
    ? `${domain}${ObtenerUri(boton.linkPdf.uri)}`
    : brochure

  return (
    <>
      {ocultar !== true && (
        <>
          {tipo === "pdf" && (
            <>
              <Button
                type="button"
                classEle="uppercase bg-negro color-pagina size-25 font-lato weight-300 boton-hover"
                eventEle={() => setModalOpen(true)}
                id={idGa}
              >
                {texto}
              </Button>
              <ReactModal
                isOpen={modalOpen}
                onRequestClose={() => setModalOpen(false)}
                contentLabel={texto || "Brochure"}
                style={customStyles}
              >
                <div className="brochure-modal">
                  {pdfSrc && (
                    <iframe
                      src={pdfSrc}
                      title={texto || "Brochure"}
                      className="brochure-modal__iframe"
                      frameBorder="0"
                    />
                  )}
                  <a
                    className="brochure-modal__fallback"
                    href={pdfSrc}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ¿No lo ves? Ábrelo en una pestaña nueva
                  </a>
                </div>
                <button
                  onClick={() => setModalOpen(false)}
                  className="form-cerrar"
                >
                  x
                </button>
              </ReactModal>
            </>
          )}
          {tipo === "galeria" && (
            <BotonGaleriaProyecto
              boton={boton}
              galeriaObra={galeriaObra}
              settings={settings}
              parrafoAvance={parrafoAvance}
            />
          )}
          {tipo === "iframe" && <BotonIframeProyecto boton={boton} />}
        </>
      )}
    </>
  )
}
export default BotonProyecto
